import "./T4SlipSetupStyle.css";

import * as yup from "yup";

import { AuthService, ClientService } from "../../../services";
import {
  BackdropCircularProgress,
  DeleteConfirmationDialog,
  EnhancedDropDownRHFWithLabel,
  EnhancedSnackbar,
  FieldLayout,
  IEnhancedDropDownItem,
  IResponse,
  IServerError,
  ITest,
  LabelPosition,
  StandardPanel,
  TwoColumnLayout,
} from "@websential/cosmic-v20";
import { Box, Button, Grid, Typography, useTheme } from "@mui/material";
import {
  EMPLOYEE_RESOURCE_LITERAL,
  GET_QUERY_KEY,
  INITIAL_SNACKBAR_DATA,
  QUERY_OPTIONS,
  T4_SETUP_SCREEN_SLUG,
} from "../../../common/constants";
import {
  EmployeeAddressSetupFieldsPanel,
  EmployeeInfoSetupFieldsPanel,
  FilingDataSetupFieldsPanel,
  FilteredSelectedOtherInfoT4,
  T4SlipDataPanel,
} from "./Panels";
import { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  PROVINCE_OF_EMPLOYMENT,
  getPROVINCE_OF_EMPLOYMENT,
} from "../../../services/common/ProvinceService";
import { findEmployeeOrSlip, scrollPanelFieldsToTop, sortDDLByLabel, useNavigateToLogout } from "../../../common/Common";
import {
  setSelectedActivityLogActions,
  setSelectedStickyNavBar,
} from "../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { Avatar } from "primereact/avatar";
import { Calendar } from "primereact/calendar";
import Card from "@mui/material/Card";
import { CityService } from "../../../services/CityService";
import { CountryService } from "../../../services/common/CountryService";
import { DDLDataTable } from "../../DDLDataTable";
import { DefaultSettingsService } from "../../../services/DefaultSettingsService";
import { Divider } from "primereact/divider";
import { Dropdown } from "primereact/dropdown";
import { EmployeeService } from "../../../services/EmployeeService";
import { EnhancedDialog } from "@websential/cosmic-v20";
import { FieldWrapper } from "../../FieldWrapper/FieldWrapper";
import FileSaver from "file-saver";
import { IAppState } from "../../../store/reducers";
import { ICountryReferenceModel } from "../../../models/common/ICountryReferenceModel";
import { IDropDownListResponse } from "../../../models/common/IDropDownListResponse";
import { IT4SlipRequestPayload } from "../../../models/t4Slip/IT4SlipRequestPayload";
import { InputText } from "primereact/inputtext";
import { InvoiceDialogPanel } from "../T4SlipList/InvoiceDialogPanel";
import { PrintingService } from "../../../services/PrintingService";
import { ReportsService } from "../../../services/ReportsService";
import { ResourceDDLDataTableForSlips } from "../../ResourceDDLDataTableForSlips";
import { T4OtherInformationService } from "../../OtherInformation/otherInformations";
import { T4SlipService } from "../../../services/T4SlipService";
import { T4SlipSetupToolbar } from "./T4SlipSetupToolbar";
import { T4SlipSetupValidationSchema } from "./validator";
import { TaxSlipSettingsService } from "../../../services/TaxSlipSettingsService";
import { format } from "date-fns";
import { instanceOfIT4SlipResponce } from "../../../common/instance-method";
import { selectedT4SummaryReduceEIType } from "../T4SlipSummaryReducedEISetup";
import { selectedT4SummaryType } from "../T4SlipSummarySetup";
import { setSelectedDrawerOptionsMenu } from "../../../store/actions/drawerMenuOptionsActions";
import { setSelectedINVOICE } from "../../../store/actions/invoiceReportActions";
import { setSelectedSlips } from "../../../store/actions/slipsActions";
import { yupResolver } from "@hookform/resolvers/yup";

export let fileeeee: any = undefined;
export let checkboxDefaultSelect: any = false;
export let selectedSlipTypee: any = 400;

export interface IT4SlipSetup extends ITest { }

const SINGLE_RECORD_DATA_QUERY_KEY = "t4-slips-single-data-record";
const SINGLE_Employee_DATA_QUERY_KEY = "employee-data";
const DEFAULT_SETTINGS_DATA_QUERY_KEY = "default-settings-data-record";
const EMPLOYEE_DDL_DATA_QUERY_KEY = "employee-ddl-data-record";

// const useGetData = (
//   id: string | undefined,
//   clientId: string,
//   taxYear: number
// ) =>
//   useQuery({
//     queryKey: [SINGLE_RECORD_DATA_QUERY_KEY, id],
//     queryFn: (data) => {
//       return T4SlipService.getT4SlipById(id, clientId, taxYear);
//     },
//     refetchOnWindowFocus: false,
//   });
const useGetData = (
  employeeId: string | null,
  provinceOfEmploymentId: string | null,
  slipType: number,
  clientId: string,
  taxYear: number
) =>
  useQuery({
    queryKey: [SINGLE_RECORD_DATA_QUERY_KEY, employeeId, provinceOfEmploymentId, slipType, clientId, taxYear],
    queryFn: (data) => {
      return T4SlipService.getT4SlipByIdAndPoeIdAndSlipType(employeeId, provinceOfEmploymentId, slipType, clientId, taxYear);
    },
    refetchOnWindowFocus: false,
  });

// const useGetGlobalVariables = (taxYear: number) =>
//   useQuery({
//     queryKey: [GET_QUERY_KEY.GET_GLOBAL_VARIABLES_BY_YEAR, taxYear],
//     queryFn: (data) => {
//       return TaxSlipSettingsService.getGlobalVariables(taxYear);
//     },
//     refetchOnWindowFocus: false,
//   });

const useGetMaskStatus = () =>
  useQuery({
    queryKey: ["mask-status"],
    queryFn: (data) => {
      return AuthService.getMaskStatus();
    },
    refetchOnWindowFocus: false,
  });

const useGetSlipRecord = (
  slipId: string,
  clientId: string,
  taxYear: number
) => {
  return useQuery({
    queryKey: [GET_QUERY_KEY.EMPLOYEE_RESOURCE_SLIP_DETAIL, slipId],
    queryFn: () => T4SlipService.getById(slipId, clientId, taxYear),
    ...QUERY_OPTIONS,
    enabled: false,
  });
};

const useGetResourceSlips = (
  resourceId: string,
  clientId: string,
  taxYear: number
) => {
  return useQuery({
    queryKey: [GET_QUERY_KEY.EMPLOYEE_RESOURCE_SLIPS_DDL, resourceId],
    queryFn: () =>
      T4SlipService.getResourceSlipDropDownList(resourceId, clientId, taxYear),
    ...QUERY_OPTIONS,
    enabled: false,
  });
};

const useGetResourceInformationById = (
  resourceId: string,
  clientId: string,
  roleName: string
) => {
  return useQuery({
    queryKey: [SINGLE_Employee_DATA_QUERY_KEY, resourceId, clientId, roleName],
    queryFn: () =>
      T4SlipService.getResourceInformationById(resourceId, clientId, roleName),
    refetchOnWindowFocus: false,
  });
};

// const useGetDefaultSettingsData = (clientId: string) =>
// 	useQuery({
// 		queryKey: [DEFAULT_SETTINGS_DATA_QUERY_KEY, clientId],
// 		queryFn: (data) => {
// 			return DefaultSettingsService.getDefaultSettings(clientId);
// 		},
// 		refetchOnWindowFocus: false,
// 	});

// const useGetDropDownList = (clientId: string) =>
//   useQuery(
//     GET_QUERY_KEY.EMPLOYEE_RESOURCE_DDL,
//     () => ResourceService.getDropDownList(clientId, "Employee"),
//     QUERY_OPTIONS
//   );

const parseJSONLikeString = (str: string) => {
  // Use regular expressions to add double quotes around keys and string values
  const modifiedString = str.replace(/(\w+):/g, '"$1":').replace(/'/g, '"');

  // Convert the modified JSON string to an object using JSON.parse()
  return JSON.parse(modifiedString);
};

// const useGetSlipIds = (tag: string, clientId: string, taxYear: number) =>
//   useQuery({
//     queryKey: ["get-slip-ids", tag, clientId, taxYear],
//     queryFn: (data) => {
//       return T4SlipService.getSlipIds(tag, clientId, taxYear);
//     },
//     refetchOnWindowFocus: false,
//   });

// const useGetCompanyData = (
//   id: string | undefined,
//   navigateToLogout: (path: any) => void
// ) =>
//   useQuery({
//     queryKey: ["client-get-by-id", id],
//     queryFn: (data) => {
//       return ClientService.getById(id, navigateToLogout);
//     },
//     refetchOnWindowFocus: false,
//   });
// const useGetCountryDDL = () =>
//   useQuery({
//     queryKey: ["country-ddl"],
//     queryFn: (data) => {
//       return CountryService.getCountryDDL();
//     },
//     refetchOnWindowFocus: false,
//   });

const T4_SUMMARY_DATA_QUERY_KEY = "get-t4-summary-data";
const T4_SUMMARY_REDUCED_EI_DATA_QUERY_KEY = "get-t4-summary-reduce-ei-data";
const useGetT4SummaryData = (
  clientid: string,
  slipType: string | number,
  taxYear: number
) =>
  useQuery({
    queryKey: [T4_SUMMARY_DATA_QUERY_KEY, clientid, slipType, taxYear],
    queryFn: (data) => {
      return T4SlipService.getT4Summary(clientid, slipType, taxYear);
    },
    refetchOnWindowFocus: false,
  });

const useGetEmployeeDDLItems = (clientId: string, taxYear: number) =>
  useQuery({
    queryKey: [EMPLOYEE_DDL_DATA_QUERY_KEY, clientId, taxYear],
    queryFn: (data) => {
      // return T4SlipService.getEmployeeDDL(clientId, taxYear);
      return T4SlipService.getEmployeeDDLForT4Slips(clientId, taxYear);
    },
    refetchOnWindowFocus: false,
  });
const useGetT4SummaryReduceEIData = (
  clientid: string,
  slipType: string | number,
  taxYear: number
) =>
  useQuery({
    queryKey: [
      T4_SUMMARY_REDUCED_EI_DATA_QUERY_KEY,
      clientid,
      slipType,
      taxYear,
    ],
    queryFn: (data) => {
      return T4SlipService.getT4SummaryReduceEI(clientid, slipType, taxYear);
    },
    refetchOnWindowFocus: false,
  });

const useGetPayFrequencyDDL = (clientId: string, taxYear: number) =>
  useQuery({
    queryKey: ["pay-frequency-ddl"],
    queryFn: (data) => {
      return EmployeeService.getPayFrequencyDDL(clientId, taxYear);
    },
    refetchOnWindowFocus: false,
  });
export const T4SlipSetup: FC<IT4SlipSetup> = ({ testId }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const navigateToLogout = useNavigateToLogout();
  const clientName = useSelector((state: IAppState) => state.client.clientName);
  const isPendingActivityLogData = useSelector(
    (state: IAppState) => state.isLoadAxiosCall.isLoading
  );
  const isAdminUser = useSelector(
    (state: IAppState) => state.user.profile.isSuperStatus
  );
  const canadaProvinces = useSelector(
    (state: IAppState) => state.countryAndProvincesInfo.canadaProvinces
  );
  const theme = useTheme();
  const [provinceDDLLoading, setProvinceDDLLoading] = useState(false);
  const [provinceStateDDLinUpdate, setProvinceStateDDLinUpdate] =
    useState<any>(undefined);
  const [cityDDLinUpdate, setCityDDLinUpdate] = useState(undefined);
  const [provinceDDLItems, setProvinceDDLItems] = useState(undefined);
  const [provinceStateLabelinUpdate, setProvinceStateLabelinUpdate] =
    useState<any>(undefined);
  const [snackbarData, setSnackbarData] = useState<any>(INITIAL_SNACKBAR_DATA);
  const clientId = useSelector((state: IAppState) => state.client.id);
  const taxYear = useSelector((state: IAppState) => state.taxYear.year);
  const countryList = useSelector(
    (state: IAppState) => state.countryAndProvincesInfo.countryDDL
  );
  const [isPendingSlipData, setIsPendingSlipData] = useState(false);
  const [isPendingSlipListDDL, setIsPendingSlipListDDL] = useState(false);
  const [selectedResourceId, setSelectedResourceId] = useState("");
  const [selectedResource, setSelectedResource] = useState("create-new");
  const [showbox17IfQC, setShowbox17IfQC] = useState(false);
  const [selectedResourceSlip, setSelectedResourceSlip] =
    useState("create-new");
  const [selectedResourceSlipList, setSelectedResourceSlipList] = useState<
    IDropDownListResponse[]
  >([{ label: "Create New", value: "create-new" }]);

  const [selectedResourceList, setSelectedResourceList] = useState<
    IDropDownListResponse[]
  >([{ label: "Create New", value: "create-new" }]);
  const [resourceListWithoutCreateNew, setResourceListWithoutCreateNew] =
    useState<any>(undefined);
  const [openInvoiceDialog, setInvoiceDialogOpen] = useState(false);
  const [invoiceData, setInvoiceData] = useState<any>([]);
  const [isPendingDataa, setIsPendingData] = useState(false);

  const [onResourceSelectionAPIsCalls, setOnResourceSelectionAPIsCalls] =
    useState(false);

  const [editedResourceId, setEditedResourceId] = useState("");
  const [selectedOtherInformation, setSelectedOtherInformation] =
    useState(false);
  const [oiInEdit, setOiInEdit] = useState(false);
  // for delete row
  const [openDialog, setDialogOpen] = useState(false);
  const [apiAction, setApiAction] = useState("");
  const [singleDelete, setSingleDelete] = useState<boolean>(false);
  const [t4SlipId, setT4SlipId] = useState<any>("");
  const [selectedProvinceOfEmployment, setSelectedProvinceOfEmployment] =
    useState("");
  const [selectedEmployee, setSelectedEmployee] = useState<any>(null);
  const [provinceOfEmploymentId, setProvinceOfEmploymentId] = useState<any>(null);
  const [slipType, setSlipType] = useState<any>(400);

  const [itemSearch, setItemSearch] = useState("");
  const [sidePanelsVisibility, setSidePanelsVisibility] = useState(true);

  //one state which store both new cretaed and edited slip data
  const [T4SlipRecord, setT4SlipRecord] = useState<any>(undefined);
  // const [selectedNotStartedResourceData, setSelectedNotStartedResourceData] = useState<any>(undefined);
  // when  I setValue of otherinformation inside async calls method then facing issue while click on add more so we have to use state method to show otherinformation
  const [slipOtherInformation, setSlipOtherInformation] = useState<any>([]);

  const [invoicePaymentFor, setInvoicePaymentFor] = useState(10);


  const [CountryResponse] = useState<ICountryReferenceModel>({
    id: 1,
    name: "Canada",
    shortCode: "CAN",
  });

  const [dateOfBirth, setDateOfBirth] = useState<any>("");



  // for edit
  const queryClient = useQueryClient();
  const { id } = useParams();

  const { isPending: isPendingPayFrequencyDDL, data: payFrequencyDDLItems } =
    useGetPayFrequencyDDL(clientId, taxYear);

  const { isPending: isPendingEmployeeDDLItems, data: employeeDDLItems } =
    useGetEmployeeDDLItems(clientId, taxYear);

  const [notStartedSlipId, setNotStartedSlipId] = useState("");
  const [completedSlipId, setCompletedSlipId] = useState("");
  // useEffect(() => {
  //   if (id !== undefined && onResourceSelectionAPIsCalls === false) {
  //     (async () => {
  //       try {
  //         const response = await T4SlipService.getT4SlipById(
  //           id,
  //           clientId,
  //           taxYear
  //         );


  //         if (
  //           response.message ===
  //           "T4 slip with this client id and year was not found."
  //         ) {
  //           setNotStartedSlipId(id);
  //         } else if (response) {
  //           setCompletedSlipId(id);
  //         }
  //       } catch (error) {
  //         console.error("Error fetching slip:", error);
  //       }
  //     })();
  //   }
  // }, [id, onResourceSelectionAPIsCalls]);

  // when Screens Reloads then which data loaded
  const isUserInteracting = useRef(false);
  // useEffect(() => {
  //   if (id !== undefined && onResourceSelectionAPIsCalls === false && employeeDDLItems) {
  //     const employeeOrSlip: { isSlipData: boolean, data: any, selectedEmployee?: any } | null = findEmployeeOrSlip(employeeDDLItems, id)
  //  
  //     if (employeeOrSlip && employeeOrSlip.isSlipData) {
  //       // slip DDL
  //       if (employeeOrSlip.selectedEmployee.totalSlips && Array.isArray(employeeOrSlip.selectedEmployee.totalSlips)) {
  //         let resourceSlipList: any[] =
  //           employeeOrSlip.selectedEmployee.totalSlips.map((resourceSlip: any) => ({
  //             label: resourceSlip.label,
  //             value: resourceSlip.value,
  //             totalSlips: resourceSlip.totalSlips,
  //             slipType: resourceSlip.slipType
  //           }));

  //         resourceSlipList.unshift({
  //           label: "Create New",
  //           value: "create-new",
  //         });



  //         setSelectedResourceSlipList(resourceSlipList);
  //       }
  //       setCompletedSlipId(employeeOrSlip.data.value);
  //       setProvinceOfEmploymentId(employeeOrSlip.data.value);
  //       setSelectedEmployee(employeeOrSlip.selectedEmployee.value);
  //       setSlipType(employeeOrSlip.data.slipType);
  //       // setT4SlipRecord(employeeOrSlip.data)
  //       // setSelectedResourceSlip(
  //       //   String(employeeOrSlip.data.value)
  //       // );
  //       // formMethods.setValue(
  //       //   "selectedSlip",
  //       //   String(employeeOrSlip.data.value)
  //       // );
  //       // slipDataByIdPass(employeeOrSlip.data, true);
  //       // setIsPendingSlipData(false)
  //       // selectedSlipTypee = formMethods.getValues("slipType");
  //       // setSelectedOtherInformation(false);
  //     } else {
  //
  //       if (employeeOrSlip) {
  //         setNotStartedSlipId(employeeOrSlip.data.value);
  //         // setSelectedNotStartedResourceData(employeeOrSlip.data.employeeData)
  //         // resourceDataByIdPass(employeeOrSlip.data.employeeData);
  //       }
  //     }
  //   }
  // }, [id, onResourceSelectionAPIsCalls, employeeDDLItems]);

  const t4SlipStoredDat = useSelector((state: IAppState) => state.slips);
  const t4SlipStoredData = useSelector((state: IAppState) => state.slips.t4);
  console.log('t4SlipStoredDatat4SlipStoredData', t4SlipStoredDat)

  useEffect(() => {
    if (!id || !employeeDDLItems || isUserInteracting.current) return;



    // // console.log('employeeDDLItemsemployeeDDLItems', employeeDDLItems)
    // const employeeOrSlip = findEmployeeOrSlip(employeeDDLItems, id);
    // if (!employeeOrSlip) return;
    // // const selectedEmployee = employeeDDLItems.find((x: any) => x.value === id);
    // // let eee = { isSlipData: selectedEmployee.totalSlips.length, data: slipMatch, selectedEmployee: empMatch }


    // console.log('ididididididididididididid', id)
    // console.log('employeeOrSlipemployeeOrSlip', employeeOrSlip)

    // if (employeeOrSlip.isSlipData) {
    //   if (Array.isArray(employeeOrSlip.selectedEmployee?.totalSlips)) {
    //     const resourceSlipList = [
    //       { label: "Create New", value: "create-new" },
    //       ...employeeOrSlip.selectedEmployee.totalSlips.map((slip: any) => ({
    //         label: slip.label,
    //         value: slip.value,
    //         totalSlips: slip.totalSlips,
    //         slipType: slip.slipType,
    //       })),
    //     ];
    //     setSelectedResourceSlipList(resourceSlipList);
    //   }
    //   setCompletedSlipId(employeeOrSlip.data.value);
    //   setProvinceOfEmploymentId(employeeOrSlip.data.value);
    //   setSelectedEmployee(employeeOrSlip.selectedEmployee.value);
    //   setSlipType(employeeOrSlip.data.slipType);
    // } else {
    //   setNotStartedSlipId(employeeOrSlip.data.value);
    // }

    if (t4SlipStoredData && t4SlipStoredData.provinceId && t4SlipStoredData.slipType) {
      console.log('t4SlipStoredData', t4SlipStoredData)
      const selectedEmployee = employeeDDLItems.find((x: any) => x.value === t4SlipStoredData.employeeId);
      if (Array.isArray(selectedEmployee?.totalSlips)) {
        const resourceSlipList = [
          { label: "Create New", value: "create-new" },
          ...selectedEmployee.totalSlips.map((slip: any) => ({
            label: slip.label,
            value: slip.value,
            totalSlips: slip.totalSlips,
            slipType: slip.slipType,
          })),
        ];
        setSelectedResourceSlipList(resourceSlipList);
      }

      // setCompletedSlipId(t4SlipStoredData.provinceId);
      setProvinceOfEmploymentId(t4SlipStoredData.provinceId);
      setSelectedEmployee(t4SlipStoredData.employeeId);
      setSlipType(t4SlipStoredData.slipType);
    } else if (t4SlipStoredData && t4SlipStoredData.employeeId && !t4SlipStoredData.provinceId) {
      setNotStartedSlipId(t4SlipStoredData.employeeId);
      const selectedEmployee = employeeDDLItems.find((x: any) => x.value === t4SlipStoredData.employeeId);
      if (Array.isArray(selectedEmployee?.totalSlips)) {
        const resourceSlipList = [
          { label: "Create New", value: "create-new" },
          ...selectedEmployee.totalSlips.map((slip: any) => ({
            label: slip.label,
            value: slip.value,
            totalSlips: slip.totalSlips,
            slipType: slip.slipType,
          })),
        ];
        setSelectedResourceSlipList(resourceSlipList);
      }
    }

  }, [id, employeeDDLItems, t4SlipStoredData]);

  const ExtendedValidationSchema = T4SlipSetupValidationSchema.shape({
    postCode: yup.string().when("country", (country: any, schema: any) => {
      const selectedCountry: any = countryList.find(
        (c: any) => c.value === country[0]
      );
      if (selectedCountry?.shortCode === "CAN") {
        return schema
          .required("Postal Code is required")
          .length(6, "Postal Code must be exactly 6 characters");
      }
      return schema; // Unchanged for other countries
    }),
    zipCode: yup.string().when("country", (country: any, schema: any) => {
      const selectedCountry = countryList.find(
        (c: any) => c.value === country[0]
      );
      if (selectedCountry?.shortCode === "USA") {
        return schema
          .required("Zip Code is required")
          .length(5, "Zip Code must be exactly 5 characters");
      }
      return schema; // Unchanged for other countries
    }),
    // dateOfBirth: yup
    // 	.string()
    // 	.nullable()
    // 	.when([], function (_, schema) {
    // 		const isRequired =
    // 			defaultSettingsData?.fillingDataAttribute?.employeeDobIsRequired &&
    // 			!defaultSettingsData?.message;
    // 		return isRequired
    // 			? schema.required("Date of Birth is required")
    // 			: schema;
    // 	}),
  });

  const DEFAULT_VALUES = {
    employmentIncome: undefined,
    cppContributions: undefined,
    secondCppContributions: undefined,
    qppContributions: undefined,
    secondQppContributions: undefined,
    eiPremiums: undefined,
    rppContributions: undefined,
    incomeTaxDeducted: undefined,
    eiInsurableEarnings: undefined,
    cppQppPensionableEarnings: undefined,
    unionDues: undefined,
    charitableDonations: undefined,
    registrationNumber: undefined,
    pensionAdjustment: undefined,
    ppipPremiums: undefined,
    ppipInsurableEarnings: undefined,

    // employee
    employeeCode: undefined,
    socialInsuranceNumber: undefined,
    firstName: undefined,
    initials: undefined,
    lastName: undefined,

    dateOfBirth: null,

    // address
    address: undefined,
    // country:undefined,
    province: undefined,
    city: undefined,
    postCode: undefined,
    zipCode: undefined,
    email: undefined,

    // filind data
    slipType: 400,
    payFrequency: 26,
    // pensionablePeriod: 26,
    provinceOfEmployment: undefined,
    cppQppExempt: false,
    eiExempt: false,
    ppipExempt: false,
    employerOfferedDentalBenefits: undefined,
    employmentCode: undefined,
    reducedEi: 0,
    slipStatus: 200,
  };

  const formMethods = useForm<any>({
    resolver: yupResolver(ExtendedValidationSchema),
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues: DEFAULT_VALUES,
  });


  // Function to sort the data array by the label field
  // sort side cards items
  const sortData = (data: IDropDownListResponse[]): IDropDownListResponse[] => {
    return data.sort((a, b) => a.label.localeCompare(b.label));
  };

  const { isPending: isSubmitting, mutate: submitFlexFields } = useMutation({
    mutationFn: T4SlipService.create,

    onSuccess: (
      res: IT4SlipRequestPayload | IServerError | IResponse | any
    ) => {

      if (res.data && instanceOfIT4SlipResponce(res.data)) {
        queryClient.invalidateQueries({
          queryKey: [SINGLE_RECORD_DATA_QUERY_KEY, res.data.id],
        });
        queryClient.invalidateQueries({
          queryKey: [EMPLOYEE_DDL_DATA_QUERY_KEY, clientId, taxYear],
        });

        formMethods.setValue("id", res.data.id);
        setSnackbarData({
          open: true,
          message: "Success",
          severity: "success",
        });
        // refectchT4SlipIds();
        scrollPanelFieldsToTop();
        if (res.status === 201 && selectedResourceSlip === "create-new") {
          // (async () => {
          //   try {

          //     const response: any =
          //       await T4SlipService.getResourceSlipDropDownList(
          //         res.data?.resource?.externalId,
          //         clientId,
          //         taxYear
          //       );
          //     if (response && Array.isArray(response)) {
          //       let resourceSlipList: IDropDownListResponse[] = response.map(
          //         (resourceSlip: IDropDownListResponse) => ({
          //           label: resourceSlip.label,
          //           value: resourceSlip.value,
          //         })
          //       );

          //       resourceSlipList.unshift({
          //         label: "Create New",
          //         value: "create-new",
          //       });


          //       setSelectedResourceSlipList(resourceSlipList);
          //       formMethods.setValue("selectedSlip", res.data.id);
          //       let path = `/compliance/t4/setup/${res.data.id}`;
          //       navigate(path);
          //     }
          //   } catch (error) {
          //     console.error("Error fetching data:", error);
          //   }
          // })();
          // setOnResourceSelectionAPIsCalls(true);
          // let path = `/compliance/t4/setup/${res.data.id}`;
          let path = `/compliance/t4/setup/${res.data.provinceOfEmployment.id}`;
          navigate(path);
          setOnResourceSelectionAPIsCalls(false);
          setSelectedResourceSlip(res.data.provinceOfEmployment.id);
        }
      } else {
        setSnackbarData({
          open: true,
          message: res.message ? res.message : res.data.message,
          severity: "error",
        });
      }


      //load slip Data
      // if (res && res.data && res.data?.resource) {
      //   setT4SlipRecord(res.data);
      //   setSelectedResource(res.data?.resource?.externalId);
      // }

      // //set slip type to 400 because when we come back to slip without reload it will automatically be original
      selectedSlipTypee = formMethods.getValues("slipType");

      // //otherinformation will update sselected items when its submitted
      setSelectedOtherInformation(true);
    },
    onError: (err: any) => {

      // TODO: customize the toast message based on the response
      setSnackbarData({
        open: true,
        // message: "Something went wrong, try again later!",
        message: err.message,
        severity: "error",
      });
    },
  });

  //when cretae-new seleted from slip ddl
  const createNewActionFromSlipDDL = () => {
    //otherinformation will update selected items
    setSelectedOtherInformation(false);
    // setIsPendingSlipData(true);
    // setTimeout(() => {
    // 	setIsPendingSlipData(false);
    // }, 1000);
    // formMethods.setValue("employmentIncome", undefined);
    // formMethods.setValue("cppContributions", undefined);
    // formMethods.setValue("secondCppContributions", undefined);
    // formMethods.setValue("eiPremiums", undefined);
    // formMethods.setValue("rppContributions", undefined);
    // formMethods.setValue("incomeTaxDeducted", undefined);
    // formMethods.setValue("eiInsurableEarnings", undefined);
    // formMethods.setValue("cppQppPensionableEarnings", undefined);
    // formMethods.setValue("unionDues", undefined);
    // formMethods.setValue("charitableDonations", undefined);
    // formMethods.setValue("registrationNumber", undefined);
    // formMethods.setValue("pensionAdjustment", undefined);
    // formMethods.setValue("ppipPremiums", undefined);
    // formMethods.setValue("ppipInsurableEarnings", undefined);
    // formMethods.setValue("slipStatus", 200);
    // formMethods.setValue("provinceOfEmployment", undefined);
    // formMethods.setValue("comparison", [{ amount: 0, code: "", label: "" }]);
    // setSlipOtherInformation([]);

    setT4SlipRecord(undefined);
    setSelectedResourceSlip("create-new");
    formMethods.setValue("selectedSlip", "create-new");
    formMethods.setValue("employmentIncome", undefined);
    formMethods.setValue("cppContributions", undefined);
    formMethods.setValue("secondCppContributions", undefined);
    formMethods.setValue("qppContributions", undefined);
    formMethods.setValue("secondQppContributions", undefined);
    formMethods.setValue("eiPremiums", undefined);
    formMethods.setValue("rppContributions", undefined);
    formMethods.setValue("incomeTaxDeducted", undefined);
    formMethods.setValue("eiInsurableEarnings", undefined);
    formMethods.setValue("cppQppPensionableEarnings", undefined);
    formMethods.setValue("unionDues", undefined);
    formMethods.setValue("charitableDonations", undefined);
    formMethods.setValue("registrationNumber", undefined);
    formMethods.setValue("pensionAdjustment", undefined);
    formMethods.setValue("ppipPremiums", undefined);
    formMethods.setValue("ppipInsurableEarnings", undefined);
    formMethods.setValue("slipStatus", 200);
    formMethods.setValue("slipType", 400);
    formMethods.setValue("cppQppExempt", false);
    formMethods.setValue("eiExempt", false);
    formMethods.setValue("ppipExempt", false);
    formMethods.setValue("reducedEi", 0);
    formMethods.setValue("comparison", []);
    setSlipOtherInformation([
      { amount: null, code: "null", label: "Empty Field" },
    ]);
    // formMethods.setValue("comparison", [{ amount: 0, code: "", label: "" }]);
    // setSlipOtherInformation([]);
  };

  // resourceDataById in function
  const resourceDataByIdPass = useCallback(
    (resourceDataById: any) => {

      setIsPendingSlipData(true);
      if (resourceDataById) {
        Object.keys(resourceDataById).forEach((fieldName) => {
          const fieldValue = resourceDataById[fieldName];



          // Always set top-level values
          formMethods.setValue(
            fieldName,
            fieldValue !== null && fieldValue !== "" ? fieldValue : ""
          );

          if (fieldName === "address") {
            Object.keys(fieldValue).forEach((resourceFieldName) => {
              const resourceFieldValue = fieldValue[resourceFieldName];
              formMethods.setValue(
                resourceFieldName,
                resourceFieldValue !== null && resourceFieldValue !== ""
                  ? resourceFieldValue
                  : ""
              );
              if (resourceFieldName === "email") {
                if (resourceFieldValue !== null) {
                  formMethods.setValue(resourceFieldName, resourceFieldValue);
                } else {
                  // const maskedStatus: any =
                  // 	sessionStorage.getItem("maskEnabled");
                  if (maskStatus) {
                    formMethods.setValue(
                      resourceFieldName,
                      "ze*****3@gmail.com"
                    );
                  } else {
                    formMethods.setValue(resourceFieldName, "");
                  }
                }
              }
              if (resourceFieldName === "countryType") {
                if (resourceDataById.address.country.shortCode === "CAN") {
                  setProvinceStateDDLinUpdate(canadaProvinces);
                  setProvinceStateLabelinUpdate(
                    resourceFieldValue ? "province" : "state"
                  );
                } else {
                  (async () => {
                    try {
                      setProvinceDDLLoading(true);
                      const responce =
                        await CountryService.getProvinceOrStateDDL(
                          navigateToLogout,
                          resourceDataById.address.country.id,
                          resourceFieldValue ? "province" : "state"
                        );

                      setProvinceStateDDLinUpdate(responce);
                      setProvinceStateLabelinUpdate(
                        resourceFieldValue ? "province" : "state"
                      );
                    } catch {

                    } finally {
                      setProvinceDDLLoading(false);
                    }
                  })();
                }
              }
              if (resourceFieldName === "country") {
                formMethods.setValue(
                  resourceFieldName,
                  resourceFieldValue.id ?? undefined
                );
              }
              if (resourceFieldName === "province") {
                formMethods.setValue(
                  resourceFieldName,
                  resourceFieldValue.id ?? undefined
                );
                (async () => {
                  try {
                    setProvinceDDLLoading(true);
                    const responce = await CityService.getCityDDL(
                      navigateToLogout,
                      resourceFieldValue.id
                    );

                    setCityDDLinUpdate(responce);
                  } catch {

                    setProvinceDDLLoading(false);
                  } finally {
                    setProvinceDDLLoading(false);
                  }
                })();
              }
              if (resourceFieldName === "state") {
                formMethods.setValue(
                  resourceFieldName,
                  resourceFieldValue.id ?? undefined
                );
              }
              if (resourceFieldName === "city") {
                // formMethods.setValue(resourceFieldName, resourceFieldValue.id ?? undefined);
                formMethods.setValue(
                  resourceFieldName,
                  resourceFieldValue.id ?? undefined
                );
              }
              if (resourceFieldName === "addressLine1") {
                formMethods.setValue("address", resourceFieldValue);
              }
            });
          }
          if (fieldName === "employeePayroll") {
            Object.keys(fieldValue).forEach((resourceFieldName) => {
              const resourceFieldValue = fieldValue[resourceFieldName];
              if (resourceFieldName === "provinceOfEmployment") {
                formMethods.setValue(
                  resourceFieldName,
                  resourceFieldValue.id ?? undefined
                );
                if (resourceFieldValue.shortCode === "QC") {
                  setShowbox17IfQC(true);
                  setSelectedProvinceOfEmployment(resourceFieldValue.name);
                } else {
                  setShowbox17IfQC(false);
                  setSelectedProvinceOfEmployment(resourceFieldValue.name);
                }
              }
              if (resourceFieldName === "payFrequency") {

                formMethods.setValue(
                  resourceFieldName,
                  Number(resourceFieldValue)
                );
                // formMethods.setValue(
                //   "pensionablePeriod",
                //   Number(resourceFieldValue)
                // );
              }
            });
          }
          if (fieldName === "socialInsuranceNumber" && fieldValue) {
            const formattedNumber = fieldValue.replace(
              /(\d{3})(\d{3})(\d{3})/,
              "$1-$2-$3"
            );
            formMethods.setValue("socialInsuranceNumber", formattedNumber);
          }
          if (fieldName === "dateOfBirth") {
            if (fieldValue !== "") {
              formMethods.setValue("dateOfBirth", fieldValue);
              if (fieldValue.charAt(2) === "*") {
                formMethods.setValue("dateOfBirth", fieldValue);
                setDateOfBirth(fieldValue);
              } else {
                const defaultDate = new Date(fieldValue);
                formMethods.setValue("dateOfBirth", defaultDate);
                setDateOfBirth(formatDate(defaultDate as Date));
              }
              // setDateOfBirthPlaceHolder(fieldValue);
            } else {
              const maskedStatus: any = sessionStorage.getItem("maskEnabled");
              if (maskedStatus === "true") {
                // setDateOfBirthPlaceHolder("0***"); //this would disable dob while value is null in upadte
              }
            }
          }
          if (fieldName === "id" && onResourceSelectionAPIsCalls === false) {
            //for auto selected card
            setSelectedEmployee(String(fieldValue));
            setSelectedResource(fieldValue);
          }
        });
        createNewActionFromSlipDDL();
        setIsPendingSlipData(false);
      }
    },
    [onResourceSelectionAPIsCalls]
  );

  // slipDataById in function
  const slipDataByIdPass = useCallback(
    (slipDataById: any, onResourceSelectionAPIsCalls: boolean) => {
      setIsPendingSlipData(true);
      // formMethods.setValue('postCode', slipDataById.resource.postCode);
      if (slipDataById) {
        Object.keys(slipDataById).forEach((fieldName) => {
          const fieldValue = slipDataById[fieldName];



          // Always set top-level values
          formMethods.setValue(fieldName, fieldValue);

          if (typeof fieldValue !== "object" || fieldValue === null) {
            formMethods.setValue(fieldName, fieldValue ?? undefined);
          } else {
            // Handle nested object fields
            Object.keys(fieldValue).forEach((objFieldName) => {
              const objFieldValue = fieldValue[objFieldName];


              if (typeof objFieldValue !== "object") {
                formMethods.setValue(objFieldName, objFieldValue ?? undefined);
              }

              if (objFieldName === "dateOfBirth") {
                if (objFieldValue) {
                  if (objFieldValue.charAt(2) === "*") {
                    formMethods.setValue("dateOfBirth", objFieldValue);
                    setDateOfBirth(objFieldValue);
                  } else {
                    const parsed = new Date(objFieldValue);
                    formMethods.setValue("dateOfBirth", parsed);
                    setDateOfBirth(formatDate(parsed));
                  }
                  // setDateOfBirthPlaceHolder(objFieldValue);
                } else {
                  // const maskedStatus = sessionStorage.getItem("maskEnabled");
                  if (maskStatus) {
                    // setDateOfBirthPlaceHolder("0***");
                  }
                }
              }

              if (fieldName === "resource") {
                if (objFieldName === "externalId") {
                  // formMethods.setValue("selectedEmployee", objFieldValue);
                  setSelectedEmployee(String(objFieldValue));
                  setSelectedResource(objFieldValue);
                  setEditedResourceId(fieldValue.externalId);
                  // if (!onResourceSelectionAPIsCalls) {
                  //   (async () => {
                  //     try {
                  //       const response =
                  //         await T4SlipService.getResourceSlipDropDownList(
                  //           objFieldValue,
                  //           clientId,
                  //           taxYear
                  //         );
                  //       if (Array.isArray(response)) {
                  //         const resourceSlipList = [
                  //           { label: "Create New", value: "create-new" },
                  //           ...response.map((r) => ({
                  //             label: r.label,
                  //             value: r.value,
                  //           })),
                  //         ];
                  //         setSelectedResourceSlipList(resourceSlipList);
                  //       }
                  //     } catch (err) {
                  //       console.error("Error fetching resource slips", err);
                  //     }
                  //   })();
                  // }
                }

                if (objFieldName === "reducedEi") {
                  formMethods.setValue("reducedEi", objFieldValue ? 1 : 0);
                }

                if (objFieldName === "email") {
                  if (objFieldValue) {
                    formMethods.setValue("email", objFieldValue);
                  } else {
                    // const maskedStatus = sessionStorage.getItem("maskEnabled");
                    formMethods.setValue(
                      "email",
                      maskStatus ? "ze*****3@gmail.com" : ""
                    );
                  }
                }
              }

              if (objFieldName === "countryType") {
                if (slipDataById.address.country.shortCode === "CAN") {
                  setProvinceStateDDLinUpdate(canadaProvinces);
                  setProvinceStateLabelinUpdate(
                    objFieldValue ? "province" : "state"
                  );
                } else {
                  (async () => {
                    try {
                      setProvinceDDLLoading(true);
                      const responce =
                        await CountryService.getProvinceOrStateDDL(
                          navigateToLogout,
                          slipDataById.address.country.id,
                          objFieldValue ? "province" : "state"
                        );
                      setProvinceStateDDLinUpdate(responce);
                      setProvinceStateLabelinUpdate(
                        objFieldValue ? "province" : "state"
                      );
                    } finally {
                      setProvinceDDLLoading(false);
                    }
                  })();
                }
              }

              if (objFieldName === "country") {
                formMethods.setValue(
                  objFieldName,
                  objFieldValue?.id ?? undefined
                );
              }

              if (objFieldName === "province") {
                formMethods.setValue(
                  objFieldName,
                  objFieldValue?.id ?? undefined
                );
                (async () => {
                  try {
                    setProvinceDDLLoading(true);
                    const responce = await CityService.getCityDDL(
                      navigateToLogout,
                      objFieldValue.id
                    );
                    setCityDDLinUpdate(responce);
                  } finally {
                    setProvinceDDLLoading(false);
                  }
                })();
              }

              if (objFieldName === "state") {
                formMethods.setValue(
                  objFieldName,
                  objFieldValue?.id ?? undefined
                );
              }

              if (objFieldName === "city") {
                formMethods.setValue(
                  objFieldName,
                  objFieldValue?.id ?? undefined
                );
              }

              if (objFieldName === "postCode") {
                formMethods.setValue(objFieldName, objFieldValue ?? "");
              }

              if (objFieldName === "provinceOfEmployment") {
                formMethods.setValue(
                  objFieldName,
                  objFieldValue?.id ?? undefined
                );
                setShowbox17IfQC(objFieldValue?.name === "Quebec");
                setSelectedProvinceOfEmployment(objFieldValue?.name || "");


                // now we get by id using poe id 
                setSelectedResourceSlip(objFieldValue?.id);
                formMethods.setValue("selectedSlip", objFieldValue?.id);
                let path = `/compliance/t4/setup/${objFieldValue?.id}`;
                navigate(path);
              }

              if (objFieldName === "socialInsuranceNumber") {
                const formatted = objFieldValue?.replace(
                  /(\d{3})(\d{3})(\d{3})/,
                  "$1-$2-$3"
                );
                formMethods.setValue("socialInsuranceNumber", formatted);
              }

              if (objFieldName !== "email" && objFieldValue === null) {
                formMethods.setValue(objFieldName, "");
              }
            });
          }
          // set slip type according to edited row data for submit button action
          if (fieldName === "slipType") {
            selectedSlipTypee = fieldValue;
            formMethods.setValue("slipType", fieldValue);
          }

          if (fieldName === "otherInformation" && fieldValue) {
            setSlipOtherInformation(fieldValue);
          }
          if (fieldName === "otherInformation") {
            setSlipOtherInformation([]);
            if (fieldValue && fieldValue !== null && fieldValue.length !== 0) {
              setOiInEdit(true);
              formMethods.setValue("comparison", fieldValue);
            } else {
              setOiInEdit(true);
              formMethods.setValue("comparison", [
                { amount: null, code: "", label: "" },
              ]);
            }
          }

          // if (fieldName === "id") {
          //   setSelectedResourceSlip(fieldValue);
          //   formMethods.setValue("selectedSlip", fieldValue);
          //   let path = `/compliance/t4/setup/${fieldValue}`;
          //   navigate(path);
          // }
          if (fieldName === "slipData") {
            Object.keys(fieldValue).forEach((slipFieldName) => {
              const slipVal = fieldValue[slipFieldName];
              formMethods.setValue(
                slipFieldName,
                slipVal !== null && slipVal !== undefined
                  ? parseFloat(slipVal).toFixed(2)
                  : undefined
              );
              if (
                [
                  "registrationNumber",
                  "employerOfferedDentalBenefits",
                ].includes(slipFieldName)
              ) {
                formMethods.setValue(slipFieldName, slipVal);
              }
            });
          }
        });
      }
      setIsPendingSlipData(false);
    },
    []
  );

  // for edit

  //for that slips which are completed
  // const { isPending: isPendingData, data: selectedT4SlipsData } = useGetData(
  //   completedSlipId,
  //   clientId,
  //   taxYear
  // );
  const { isPending: isPendingData, data: selectedT4SlipsData } = useGetData(
    selectedEmployee,
    provinceOfEmploymentId,
    slipType,
    clientId,
    taxYear
  );
  // const { isPending: isPendingDefaultSettingsData, data: defaultSettingsData } =
  // 	useGetDefaultSettingsData(clientId);

  // const { isPending: isPendingGlobalVariables, data: editDataRecord } =
  //   useGetGlobalVariables(taxYear);
  // const globalVariablesData: any = editDataRecord;

  // const {
  // 	isPending: loadingSlipIds,
  // 	data: t4SlipIds,
  // 	refetch: refectchT4SlipIds,
  // } = useGetSlipIds("T4", clientId, taxYear);

  const { isPending: isPendingMaskStatus, data: maskStatus } =
    useGetMaskStatus();

  useEffect(() => {
    if (employeeDDLItems) {
      if (employeeDDLItems && Array.isArray(employeeDDLItems)) {
        let resources: any[] = sortDDLByLabel(employeeDDLItems).map(
          (resourceItem: any) => ({
            // id: resourceItem.id,
            label: resourceItem.label,
            value: resourceItem.value,
          })
        );

        resources.unshift({
          label: "Create New",
          value: "create-new",
        });

        setSelectedResourceList(resources);
      }
      setResourceListWithoutCreateNew(sortData(employeeDDLItems));
    }
  }, [employeeDDLItems]);

  // const { isPending: isPendingClientDataById, data: companyGetByIdRecord } =
  // 	useGetCompanyData(clientId, navigateToLogout);

  // const { isPending: isPendingCountryDDL, data: countryList } =
  //   useGetCountryDDL();

  const { isPending: isPendingSummaryGetData, data: t4SummaryData } =
    useGetT4SummaryData(clientId, selectedT4SummaryType, taxYear);
  const {
    isPending: isPendingSummaryReduceEIGetData,
    data: t4SummaryReduceEIData,
  } = useGetT4SummaryReduceEIData(
    clientId,
    selectedT4SummaryReduceEIType,
    taxYear
  );

  // useEffect(() => {

  // 	if (companyGetByIdRecord && companyGetByIdRecord.metaFields) {
  // 		const paymentFor = companyGetByIdRecord.metaFields.find(
  // 			(item: any) => item.name === "invoice_payment_for"
  // 		);
  //
  // 		setInvoicePaymentFor(paymentFor ? parseInt(paymentFor.value) : 10);
  // 	}
  // }, [companyGetByIdRecord]);

  useEffect(() => {
    if (selectedT4SlipsData) {
      setT4SlipRecord(selectedT4SlipsData);
    }
  }, [selectedT4SlipsData]);


  //for that slips which are not started yet
  const {
    isPending: isPendingNotStartedSlipId,
    data: selectedNotStartedResourceData,
    // refetch: refetchResourceSlips,
  } = useGetResourceInformationById(notStartedSlipId, clientId, "Employee");


  /**
   * Handle when the form is submitted.
   *
   * @param {IT4SlipRequestPayload} formData
   */

  const [T4OtherInformationList, setT4OtherInformationList] =
    useState<any>(undefined);
  useEffect(() => {
    //Load OtherInformationList
    setIsPendingSlipData(true);
    setTimeout(() => {
      setIsPendingSlipData(false);
    }, 2000);
    const fetchData = async () => {
      try {
        const response: any = await T4OtherInformationService.getT4OI();
        setT4OtherInformationList(response);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const [isDOBAtLeast10YearsAgo, setIsDOBAtLeast10YearsAgo] = useState(false);

  const onSubmit = async (formData: any) => {

    const SelectedCountry: any = countryList.find(
      (e: any) => e.value === formData.country
    );

    try {
      setIsPendingData(true);
      const ProvinceOrStateDDL = await CountryService.getProvinceOrStateDDL(
        navigateToLogout,
        SelectedCountry.value,
        SelectedCountry.countryType
      );
      const selectedProvinceOrState = formData.province
        ? ProvinceOrStateDDL.find((e: any) => e.value === formData.province)
        : formData.state
          ? ProvinceOrStateDDL.find((e: any) => e.value === formData.state)
          : undefined;

      const selectedPOE =
        formData.provinceOfEmployment &&
        ProvinceOrStateDDL.find(
          (e: any) => e.value === formData.provinceOfEmployment
        );


      //other Information
      const getValue = formMethods.getValues("comparison");

      const finalOtherInformatioItems = FilteredSelectedOtherInfoT4.map(
        (item: any) => {
          const valueItem = getValue.find(
            (value: any) => value.code === item.code
          );
          const getLabelIfMissingInItem =
            T4OtherInformationList &&
            T4OtherInformationList.find(
              (value: any) => value.value === item.code
            );

          return {
            ...item,
            amount: valueItem.amount,
            label: getLabelIfMissingInItem.label,
          };
        }
      );


      const requestPayload: IT4SlipRequestPayload = {
        // clientId: formData.clientId,
        // taxYear:formData.taxYear,
        // id: formData.id,
        clientId: clientId,
        taxYear: taxYear,
        id:
          T4SlipRecord && T4SlipRecord.resource
            ? // && editedRecordSlipCreateNew === false
            T4SlipRecord.id
            : T4SlipRecord && T4SlipRecord.id
              ? T4SlipRecord.id
              : // : newCreatedSlipId !== '' && editedRecordSlipCreateNew === false ? newCreatedSlipId
              undefined,
        ignoredEiAuditEarning: false, //this tag is for audit earnings ignore tag
        ignoredCppAuditEarning: false, //this tag is for audit earnings ignore tag
        ignoredDuplicateSlips: false, //ignore duplicate employees
        // reflectMasterData: formData.reflectMasterData,
        slipType: formData.slipType,
        slipStatus: formData.slipStatus,
        // pensionablePeriod: formData.pensionablePeriod,
        otherInformation:
          formData.comparison[0].code !== "" ? finalOtherInformatioItems : [],
        resource: {
          externalId:
            selectedResource !== "create-new"
              ? selectedResource
              : T4SlipRecord && T4SlipRecord.resource
                ? T4SlipRecord.resource.externalId
                : // : newCreatedResourceId !== '' ? newCreatedResourceId
                selectedNotStartedResourceData &&
                  selectedNotStartedResourceData.id
                  ? selectedNotStartedResourceData.id
                  : undefined,
          firstName: formData.firstName,
          initials: formData.initials,
          lastName: formData.lastName,
          // dateOfBirth: formData.dateOfBirth,
          // dateOfBirth:
          // 	dateOfBirth.charAt(2) === "*"
          // 		? undefined
          // 		: dateOfBirth !== "" || null
          // 		? dateOfBirth
          // 		: undefined,
          dateOfBirth:
            formData.dateOfBirth !== "" && formatDate(formData.dateOfBirth),
          socialInsuranceNumber: formData.socialInsuranceNumber.replace(
            /-/g,
            ""
          ),
          address: formData.address,
          city: formData.city,
          // province: provinceObject, //when edit then it show n select so this technique is use bcz we cant assign fieldvalue according to field name by using direct object so first we change that oobject to string then we chnage that string to obj and send to payload
          // country: CountryResponse,
          countryType: formData.province ? true : false,
          country: {
            id: SelectedCountry.value,
            name: SelectedCountry.label,
            shortCode: SelectedCountry.shortCode,
          },
          province: formData.province
            ? {
              id: selectedProvinceOrState.value,
              name: selectedProvinceOrState.label,
              shortCode: selectedProvinceOrState.shortCode,
            }
            : undefined,
          states: formData.state
            ? {
              id: selectedProvinceOrState.value,
              name: selectedProvinceOrState.label,
              shortCode: selectedProvinceOrState.shortCode,
            }
            : undefined,
          provinceOfEmployment: selectedPOE
            ? {
              id: selectedPOE.value,
              name: selectedPOE.label,
              shortCode: selectedPOE.shortCode,
            }
            : undefined,
          // postCode:
          //   formData.postalCode &&
          //   formData.postalCode.replace(/[a-z]/g, (match: string) =>
          //     match.toUpperCase()
          //   ),
          postCode: formData.postCode
            ? formData.postCode.replace(/[a-z]/g, (match: string) =>
              match.toUpperCase()
            )
            : undefined,
          zipCode: formData.zipCode ? formData.zipCode : undefined,

          // provinceOfEmployment: poeObject,
          email:
            formData.email !== "" && formData.email !== "ze*****3@gmail.com"
              ? formData.email
              : undefined,
          employeeCode: parseInt(formData.employeeCode),
          // employeeCode: formData.employeeCode,
          cppQppExempt: formData.cppQppExempt,
          eiExempt: formData.eiExempt,
          ppipExempt: formData.ppipExempt,
          employmentCode:
            formData.employmentCode !== undefined &&
              formData.employmentCode !== ""
              ? formData.employmentCode
              : null,
          payFrequency: formData.payFrequency,
          reducedEi: formData.reducedEi,
        },
        overRemittance: 0,
        slipData: {
          employmentIncome:
            formData.employmentIncome && formData.employmentIncome !== null
              ? formData.employmentIncome
              : 0,
          cppContributions:
            selectedProvinceOfEmployment !== "Quebec" &&
              formData.cppContributions &&
              formData.cppContributions !== null
              ? formData.cppContributions
              : 0,
          secondCppContributions:
            selectedProvinceOfEmployment !== "Quebec" &&
              taxYear > 2023 &&
              formData.secondCppContributions &&
              formData.secondCppContributions !== null
              ? formData.secondCppContributions
              : 0,
          qppContributions:
            selectedProvinceOfEmployment === "Quebec" &&
              formData.qppContributions !== null &&
              formData.qppContributions !== undefined
              ? formData.qppContributions
              : 0,
          secondQppContributions:
            selectedProvinceOfEmployment === "Quebec" &&
              taxYear > 2023 &&
              formData.secondQppContributions !== null &&
              formData.secondQppContributions !== undefined
              ? formData.secondQppContributions
              : 0,
          eiPremiums:
            formData.eiPremiums && formData.eiPremiums !== null
              ? formData.eiPremiums
              : 0,
          rppContributions:
            formData.rppContributions && formData.rppContributions !== null
              ? formData.rppContributions
              : 0,
          incomeTaxDeducted:
            formData.incomeTaxDeducted && formData.incomeTaxDeducted !== null
              ? formData.incomeTaxDeducted
              : 0,
          eiInsurableEarnings:
            formData.eiInsurableEarnings &&
              formData.eiInsurableEarnings !== null
              ? formData.eiInsurableEarnings
              : 0,
          cppQppPensionableEarnings:
            formData.cppQppPensionableEarnings &&
              formData.cppQppPensionableEarnings !== null
              ? formData.cppQppPensionableEarnings
              : 0,
          unionDues:
            formData.unionDues && formData.unionDues !== null
              ? formData.unionDues
              : 0,
          charitableDonations:
            formData.charitableDonations &&
              formData.charitableDonations !== null
              ? formData.charitableDonations
              : 0,
          registrationNumber:
            formData.registrationNumber && formData.registrationNumber !== null
              ? parseInt(formData.registrationNumber)
              : undefined,
          pensionAdjustment:
            formData.pensionAdjustment && formData.pensionAdjustment !== null
              ? formData.pensionAdjustment
              : 0,
          ppipPremiums:
            formData.ppipPremiums && formData.ppipPremiums !== null
              ? formData.ppipPremiums
              : 0,
          ppipInsurableEarnings:
            formData.ppipInsurableEarnings &&
              formData.ppipInsurableEarnings !== null
              ? formData.ppipInsurableEarnings
              : 0,
          employerOfferedDentalBenefits:
            formData.employerOfferedDentalBenefits &&
              formData.employerOfferedDentalBenefits !== ""
              ? formData.employerOfferedDentalBenefits
              : null,
        },
        t4SummaryConfirmationCode:
          t4SummaryData && t4SummaryData.confirmationCode,
        t4SummaryReduceEIConfirmationCode:
          t4SummaryReduceEIData && t4SummaryReduceEIData.confirmationCode,
        selectedSlipTypeById: T4SlipRecord && T4SlipRecord.slipType,
      };

      submitFlexFields(requestPayload);
    } catch {

    } finally {
      setIsPendingData(false);
    }
  };

  const onResetClicked = () => {
    setSnackbarData({
      open: true,
      message: "Success",
      severity: "success",
    });
    formMethods.reset();
    formMethods.setValue("comparison", [{ amount: null, code: "", label: "" }]);
    setSlipOtherInformation([]);
    setDateOfBirth("");
    // setDateOfBirthPlaceHolder("");
    setSelectedResourceSlipList([{ label: "Create New", value: "create-new" }]);
    setSelectedResourceSlip("create-new");
    setSelectedOtherInformation(false);
    setSelectedResource("create-new");
    setSelectedEmployee(null);
    scrollPanelFieldsToTop();
    let path = `/compliance/t4/setup`;
    navigate(path);
    setT4SlipRecord(undefined);
    // defaultSettingsCalls();
  };

  // For Delete Row

  const { isPending: isDeleting, mutate: deleteT4SlipById } = useMutation({
    mutationFn: T4SlipService.delT4Slip,

    onSuccess: (res: any | IServerError | IResponse) => {

      if (typeof res === "string") {
        // remove the cache of the Year fields since we just added a new field.
        setSnackbarData({
          open: true,
          message: "Success",
          severity: "success",
        });
        setT4SlipRecord(undefined);
        scrollPanelFieldsToTop();
        // defaultSettingsCalls();
        // refectchT4SlipIds();
      } else {
        setSnackbarData({
          open: true,
          // message: "Something went wrong, try again later!",
          message: res.message,
          severity: "error",
        });
      }

      //load Employee Data
      if (res) {
        const selectedEmployee = formMethods.getValues("selectedEmployee");

        if (selectedEmployee !== "create-new") {
          let path = `/compliance/t4/setup/${selectedEmployee}`;
          navigate(path);
          const fetchData = async () => {
            try {
              const response: any =
                await T4SlipService.getResourceSlipDropDownList(
                  selectedEmployee,
                  clientId,
                  taxYear
                );


              if (response && Array.isArray(response)) {
                let resourceSlipList: IDropDownListResponse[] = response.map(
                  (resourceSlip: IDropDownListResponse) => ({
                    label: resourceSlip.label,
                    value: resourceSlip.value,
                  })
                );

                resourceSlipList.unshift({
                  label: "Create New",
                  value: "create-new",
                });


                setSelectedResourceSlipList(resourceSlipList);
                formMethods.setValue("selectedSlip", resourceSlipList[0].value);
                createNewActionFromSlipDDL();
                formMethods.setValue("comparison", [
                  { amount: null, code: "", label: "" },
                ]);
              }
            } catch (error) {
              console.error("Error fetching data:", error);
            }
          };

          fetchData();
        }
      }

      //set slip type to 400 because when we come back to slip without reload it will automatically be original
      selectedSlipTypee = formMethods.getValues("slipType");

      //otherinformation will update sselected items when its submitted
      setSelectedOtherInformation(true);
    },
    onError: (err: any) => {

      // TODO: customize the toast message based on the response
      setSnackbarData({
        open: true,
        // message: "Something went wrong, try again later!",
        message: err.message,
        severity: "error",
      });
    },
  });

  const deleteT4SlipField = () => {
    if (singleDelete) {
      let payload = {
        t4SlipId,
        clientId,
        taxYear,
      };
      setSingleDelete(false);
      deleteT4SlipById(payload);
      setDialogOpen(false);
    }
  };

  const onDeleteClicked = () => {
    setDialogOpen(true);
    setSingleDelete(true);
    setApiAction("delete");
    if (
      T4SlipRecord &&
      T4SlipRecord.resource
      // && editedRecordSlipCreateNew === false
    ) {
      setT4SlipId(T4SlipRecord.id);
    }
    // else if (slipRecord && slipRecord.id){
    //   setT4SlipId(slipRecord.id)
    // }
    // else if(newCreatedSlipId !== '' && editedRecordSlipCreateNew === false){
    //   setT4SlipId(newCreatedSlipId)
    // }
    // setT4SlipId(params.row.id);


    // setSnackbarData({
    //   open: true,
    //   message: "Success",
    //   severity: "success",
    // });
    // formMethods.reset();
  };

  const savePdfAsFile = (pdfData: any, filename: any) => {
    const blob = new Blob([pdfData], { type: "application/pdf" });
    FileSaver.saveAs(blob, filename);

    fileeeee = pdfData;
  };
  const onPrintClicked = async (printType: any): Promise<void> => {
    const maskedStatus: any = sessionStorage.getItem("maskEnabled");
    if (maskedStatus === "true") {
      setIsPendingData(false);
      setSnackbarData({
        open: true,
        message: "Please unmask your data.",
        severity: "error",
      });
    } else {
     
      // setIsPendingData(true);
      // if (invoicePaymentFor === 10) {
      // 	try {
      // 		const previousYearInvoiceResponse: any =
      // 			await ReportsService.getPreviousYearInvoice(clientId, taxYear - 1);
      // 		try {
      // 			const response: any = await ReportsService.createInvoice(
      // 				clientId,
      // 				taxYear
      // 			);
      // 			setIsPendingData(false);

      // 			if (
      // 				previousYearInvoiceResponse.message ===
      // 					"Slips not found for invoice." &&
      // 				response.message === "Slips not found for invoice."
      // 			) {
      // 				if (
      // 					t4SlipIds &&
      // 					t4SlipIds.generalAuditStatus !== null &&
      // 					t4SlipIds.generalAuditStatus === true &&
      // 					t4SlipIds &&
      // 					t4SlipIds.auditStatus !== null &&
      // 					t4SlipIds.auditStatus === true
      // 				) {

      setIsPendingData(true);

      try {
        // const jsonString = formMethods.getValues("provinceOfEmployment")
        //   ? formMethods.getValues("provinceOfEmployment")
        //   : ('{id:9, name: "Ontario",shortCode:"ON"}' as string);
        // const ProvinceOfEmploymentData = parseJSONLikeString(jsonString);
        // let pdfIds = `t4_slip_ids=${id}`;


        let requestPayload = [
          {
            // "employeeId": T4SlipRecord.employeeId,
            // "slipType": T4SlipRecord.slipType === "Original" ? 400 : T4SlipRecord.slipType === "Amended" ? 200 : T4SlipRecord.slipType === "Cancelled" ? 300 : 100,
            // "provinceId": T4SlipRecord.provinceId


            "employeeId": T4SlipRecord.resource.externalId,
            "slipType": T4SlipRecord.slipType,
            "provinceId": T4SlipRecord.resource.provinceOfEmployment.id
          }
        ]

        const response: any = await PrintingService.createBulkT4PdfPrint(
          clientId,
          printType,
          // pdfIds,
          taxYear,
          requestPayload
        );
        if (response.status === 400) {
          setSnackbarData({
            open: true,
            message: response.data.message
              ? response.data.message
              : "Something went wrong.",
            // message: "Please Unmask sensitive data for PDF printing.",
            severity: "error",
          });
        } else {
          const employeeFirstName = formMethods.getValues("firstName");
          const employeeLastName = formMethods.getValues("lastName");
          const filename = `T4slip-${employeeFirstName} ${employeeLastName}-${printType}.pdf`;
          savePdfAsFile(response, filename);

        }
      } catch (err) {
        setIsPendingData(false);
        // alert(err);
      } finally { setIsPendingData(false); }

      // 				} else {
      // 					setIsPendingData(false);
      // 					setSnackbarData({
      // 						open: true,
      // 						message: (
      // 							<>
      // 								Please load Audit in the menu, press Run T4 Audit and
      // 								clear all audit items (Audit Filing and PIER Review) to
      // 								generate documents.{" "}
      // 								<a
      // 									href="https://appv3.taxslips.com/#/audit/filing"
      // 									style={{
      // 										color: "#aa1010",
      // 										textDecoration: "none",
      // 										fontWeight: "bold",
      // 									}}
      // 								>
      // 									Click here to view
      // 								</a>
      // 							</>
      // 						),
      // 						severity: "error",
      // 						autoHide: false,
      // 					});
      // 				}
      // 			} else if (
      // 				response?.id != null &&
      // 				previousYearInvoiceResponse?.id != null
      // 			) {
      // 				
      // 				setInvoiceData([previousYearInvoiceResponse, response]);
      // 				setInvoiceDialogOpen(true);
      // 			} else if (
      // 				previousYearInvoiceResponse?.id != null &&
      // 				response?.message === "Slips not found for invoice."
      // 			) {
      // 				
      // 				setInvoiceData([previousYearInvoiceResponse]);
      // 				setInvoiceDialogOpen(true);
      // 			} else if (
      // 				response?.id != null &&
      // 				previousYearInvoiceResponse?.message ===
      // 					"Slips not found for invoice."
      // 			) {
      // 			
      // 				setInvoiceData([response]);
      // 				setInvoiceDialogOpen(true);
      // 			} else {
      // 				setSnackbarData({
      // 					open: true,
      // 					message: "Something went wrong.",
      // 					severity: "error",
      // 				});
      // 			}
      // 			setIsPendingData(false);
      // 		} catch (err) {
      // 		
      // 			setIsPendingData(false);
      // 		}
      // 	} catch (err) {
      // 	
      // 		setIsPendingData(false);
      // 	}
      // } else {
      // 	try {
      // 		const response: any = await ReportsService.createInvoice(
      // 			clientId,
      // 			taxYear
      // 		);
      // 		setIsPendingData(false);
      // 
      // 		if (response.message === "Slips not found for invoice.") {
      // 			if (
      // 				t4SlipIds &&
      // 				t4SlipIds.generalAuditStatus !== null &&
      // 				t4SlipIds.generalAuditStatus === true &&
      // 				t4SlipIds &&
      // 				t4SlipIds.auditStatus !== null &&
      // 				t4SlipIds.auditStatus === true
      // 			) {
      // 				setIsPendingData(true);
      // 				try {
      // 					const jsonString = formMethods.getValues("provinceOfEmployment")
      // 						? formMethods.getValues("provinceOfEmployment")
      // 						: ('{id:9, name: "Ontario",shortCode:"ON"}' as string);
      // 					const ProvinceOfEmploymentData =
      // 						parseJSONLikeString(jsonString);
      // 					let pdfIds = `t4_slip_ids=${id}`;
      // 					const response: any =
      // 						await PrintingService.createBulkT4PdfPrint(
      // 							clientId,
      // 							printType,
      // 							pdfIds,
      // 							taxYear
      // 						);
      // 					if (response.status === 400) {
      // 						setSnackbarData({
      // 							open: true,
      // 							message: response.data.message
      // 								? response.data.message
      // 								: "Something went wrong.",
      // 							severity: "error",
      // 						});
      // 					} else {
      // 						const employeeFirstName = formMethods.getValues("firstName");
      // 						const employeeLastName = formMethods.getValues("lastName");
      // 						const filename = `T4slip-${employeeFirstName} ${employeeLastName}-${printType}.pdf`;
      // 						savePdfAsFile(response, filename);
      // 					
      // 					}
      // 					setIsPendingData(false);
      // 				} catch (err) {
      // 					
      // 					alert(err);
      // 				}
      // 				setIsPendingData(false);
      // 			} else {
      // 				setIsPendingData(false);
      // 				setSnackbarData({
      // 					open: true,
      // 					message: (
      // 						<>
      // 							Please load Audit in the menu, press Run T4 Audit and clear
      // 							all audit items (Audit Filing and PIER Review) to generate
      // 							documents.{" "}
      // 							<a
      // 								href="https://appv3.taxslips.com/#/audit/filing"
      // 								style={{
      // 									color: "#aa1010",
      // 									textDecoration: "none",
      // 									fontWeight: "bold",
      // 								}}
      // 							>
      // 								Click here to view
      // 							</a>
      // 						</>
      // 					),
      // 					severity: "error",
      // 					autoHide: false,
      // 				});
      // 			}
      // 		} else if (response && response.id !== null) {
      // 			setInvoiceData([response]);
      // 			setInvoiceDialogOpen(true);
      // 		} else {
      // 			setSnackbarData({
      // 				open: true,
      // 				message: "Something went wrong.",
      // 				severity: "error",
      // 			});
      // 		}
      // 		setIsPendingData(false);
      // 	} catch (err) {
      // 	
      // 		setIsPendingData(false);
      // 	}
      // }
    }
  };



  const onUnPaidClickHandler = (clickedRow: any, tag: string) => {
    setIsPendingData(true);
    // setTimeout(() => {
    //   setIsPendingData(false);
    // }, 2500);
    const fetchData = async () => {
      try {
        const response: any =
          await ReportsService.paypalIntegrationOfUnpaidInvoice(
            clientId,
            clickedRow.refNo,
            tag
          );
        setIsPendingData(false);

        if (tag === "paypal") {
          window.open(response, "_blank");
        } else {
          window.open(response.message, "_blank");
        }
      } catch (error) {
        setIsPendingData(false);
        console.error("Error fetching data:", error);
      } finally {
        setIsPendingData(false);
      }
    };
    fetchData();

  };

  const onClickInvoiceNoHandler = (clickedRow: any) => {
    dispatch(setSelectedINVOICE(clickedRow));

  };
  /**
   * On Snackbar closed.
   *
   * @param {React.SyntheticEvent | Event} event
   * @param {string} reason
   */
  const onSnackbarClosed = (
    event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarData(INITIAL_SNACKBAR_DATA);
  };

  // format date to 2023-07-26
  const formatDate = (date: Date): string => {
    return format(date, "yyyy-MM-dd"); // Format the date as "yyyy-MM-dd"
  };

  const onDateOfBirthChangeHandler = (selectedDate: any) => {

    if (selectedDate.value) {

      // alert(formatDate(selectedDate.value as Date));
      setDateOfBirth(formatDate(selectedDate.value as Date));
    } else {
      setDateOfBirth("");
    }
  };

  const onResourceSelectionChangeHandler = async (
    selectedItem: IEnhancedDropDownItem | any
  ): Promise<void> => {
    formMethods.reset();
    isUserInteracting.current = true; // sync, immediate
    setOnResourceSelectionAPIsCalls(true);
    // (async () => {
    //   try {
    //     setIsPendingSlipData(true);
    //     let resourceDataById = await T4SlipService.getResourceInformationById(
    //       selectedItem.value,
    //       clientId,
    //       "Employee"
    //     );

    //     if (resourceDataById) {
    //       Object.keys(resourceDataById).forEach((fieldName) => {
    //         // @ts-ignore
    //         const fieldValue = resourceDataById[fieldName];
    //         if (fieldName === "id") {
    //           // formMethods.setValue("selectedEmployee", fieldValue);

    //           setSelectedEmployee(String(fieldValue));
    //           (async () => {
    //             try {
    //               const response: any =
    //                 await T4SlipService.getResourceSlipDropDownList(
    //                   fieldValue,
    //                   clientId,
    //                   taxYear
    //                 );
    //               if (response && Array.isArray(response)) {
    //                 let resourceSlipList: IDropDownListResponse[] =
    //                   response.map((resourceSlip: IDropDownListResponse) => ({
    //                     label: resourceSlip.label,
    //                     value: resourceSlip.value,
    //                   }));

    //                 resourceSlipList.unshift({
    //                   label: "Create New",
    //                   value: "create-new",
    //                 });


    //                 setSelectedResourceSlipList(resourceSlipList);
    //                 if (resourceSlipList && resourceSlipList.length > 1) {
    //                   (async () => {
    //                     try {

    //                       // setIsPendingSlipData(true);
    //                       let slipDataById = await T4SlipService.getT4SlipById(
    //                         String(resourceSlipList[1].value),
    //                         clientId,
    //                         taxYear
    //                       );
    //                       setT4SlipRecord(slipDataById);
    //                       setSelectedResourceSlip(
    //                         String(resourceSlipList[1].value)
    //                       );
    //                       formMethods.setValue(
    //                         "selectedSlip",
    //                         String(resourceSlipList[1].value)
    //                       );

    //                       slipDataByIdPass(slipDataById, true);
    //                       //set slip type to 400 because when we come back to slip without reload it will automatically be original
    //                       selectedSlipTypee = formMethods.getValues("slipType");

    //                       //otherinformation will update sselected items when its submitted
    //                       //  setSelectedOtherInformation(true)
    //                       setSelectedOtherInformation(false);
    //                     } catch (error) {
    //                       setIsPendingSlipData(false);
    //                       console.error("Error fetching data:", error);
    //                     } finally {
    //                       // setSelectedResourceSlip(
    //                       // 	String(resourceSlipList[1].value)
    //                       // );
    //                       // formMethods.setValue(
    //                       // 	"selectedSlip",
    //                       // 	String(resourceSlipList[1].value)
    //                       // );
    //                       // let path = `/compliance/t4/setup/${resourceSlipList[1].value}`;
    //                       // navigate(path);
    //                       setIsPendingSlipData(false);
    //                     }
    //                   })();
    //                 } else {
    //                   resourceDataByIdPass(resourceDataById);
    //                   // setSelectedEmployee('create-new')
    //                   setSelectedResource(String(selectedItem.value));
    //                   setEditedResourceId(String(selectedItem.value));
    //                   let path = `/compliance/t4/setup/${selectedItem.value}`;
    //                   navigate(path);
    //                   setIsPendingSlipData(false);
    //                 }
    //               }
    //             } catch (error) {
    //               console.error("Error fetching data:", error);
    //             }
    //           })();
    //           setSelectedResource(fieldValue);
    //         }
    //       });
    //     }
    //   } catch (error) {
    //     setIsPendingSlipData(false);
    //     console.error("Error fetching data:", error);
    //   }
    // })();

    let selectedEmployee = selectedItem
    console.log('selectedEmployeeselectedEmployee-=', selectedEmployee)

    setSelectedEmployee(String(selectedEmployee.value));
    setSelectedResource(String(selectedItem.value));
    if (selectedEmployee.totalSlips && Array.isArray(selectedEmployee.totalSlips)) {
      setIsPendingSlipData(true)
      let resourceSlipList: any[] =
        sortDDLByLabel(selectedEmployee.totalSlips).map((resourceSlip: any) => ({
          label: resourceSlip.label,
          value: resourceSlip.value,
          totalSlips: resourceSlip.totalSlips,
          slipType: resourceSlip.slipType
        }));

      resourceSlipList.unshift({
        label: "Create New",
        value: "create-new",
      });



      setSelectedResourceSlipList(resourceSlipList);
      console.log("resourceSlipList-=-=", resourceSlipList)

      if (resourceSlipList && resourceSlipList.length > 1) {
        setProvinceOfEmploymentId(String(resourceSlipList[1].value));
        setSelectedResourceSlip(
          String(resourceSlipList[1].value)
        );
        formMethods.setValue(
          "selectedSlip",
          String(resourceSlipList[1].value)
        );
        selectedSlipTypee = formMethods.getValues("slipType");
        setSelectedOtherInformation(false);

        dispatch(setSelectedSlips({ t4: { employeeId: selectedItem.value, provinceId: resourceSlipList[1].value, slipType: resourceSlipList[1].slipType } }));
        // (async () => {
        //   try {
        //     let slipDataById = await T4SlipService.getT4SlipByIdAndPoeIdAndSlipType(
        //       selectedItem.value,
        //       String(resourceSlipList[1].value),
        //       resourceSlipList[1].slipType,
        //       clientId,
        //       taxYear
        //     );
        //     setT4SlipRecord(slipDataById);
        //     setSelectedResourceSlip(
        //       String(resourceSlipList[1].value)
        //     );
        //     formMethods.setValue(
        //       "selectedSlip",
        //       String(resourceSlipList[1].value)
        //     );
        //     slipDataByIdPass(slipDataById, true);
        //     selectedSlipTypee = formMethods.getValues("slipType");
        //     setSelectedOtherInformation(false);
        //   } catch { }
        // })();
        setOnResourceSelectionAPIsCalls(false);
      } else {
        (async () => {
          try {
            setIsPendingSlipData(true);
            let resourceDataById = await T4SlipService.getResourceInformationById(
              selectedItem.value,
              clientId,
              "Employee"
            );
            resourceDataByIdPass(resourceDataById);
          } catch { }
          finally {
            // ✅ reset here too
            setOnResourceSelectionAPIsCalls(false);
          }
        })();
        // setSelectedEmployee('create-new')
        setSelectedResource(String(selectedItem.value));
        setEditedResourceId(String(selectedItem.value));
        let path = `/compliance/t4/setup/${selectedItem.value}`;
        navigate(path);
        setIsPendingSlipData(false);
      }
      setIsPendingSlipData(false)
    }
    setSelectedOtherInformation(false);
  };

  const onResourceSlipSelectionChangeHandler = (
    selectedItem: IEnhancedDropDownItem | any
  ) => {
    isUserInteracting.current = true; // sync, immediate
    setOnResourceSelectionAPIsCalls(true);
    if (selectedItem.value === "create-new") {
      setProvinceOfEmploymentId(null);
      setNotStartedSlipId("")
      dispatch(setSelectedSlips({ t4: { employeeId: selectedEmployee, provinceId: null, slipType: null } }));
      createNewActionFromSlipDDL();
      setT4SlipRecord(undefined);
      setSelectedResourceSlip("create-new");
      if (selectedResource !== "create-new") {
        setOnResourceSelectionAPIsCalls(false);
        let path = `/compliance/t4/setup/${selectedResource}`;
        navigate(path);
        // window.location.reload();
      }
    }
    if (selectedItem.value !== "create-new") {
      dispatch(setSelectedSlips({ t4: { employeeId: selectedEmployee, provinceId: selectedItem.value, slipType: selectedItem.slipType } }));
      (async () => {
        try {
          setIsPendingSlipData(true);
          // let slipDataById = await T4SlipService.getT4SlipById(
          //   String(selectedItem.value),
          //   clientId,
          //   taxYear
          // );
          let slipDataById = await T4SlipService.getT4SlipByIdAndPoeIdAndSlipType(
            selectedEmployee,
            selectedItem.value,
            selectedItem.slipType,
            clientId,
            taxYear
          );
          setT4SlipRecord(slipDataById);

          slipDataByIdPass(slipDataById, true);
          selectedSlipTypee = formMethods.getValues("slipType");
          setSelectedOtherInformation(false);
          setIsPendingSlipData(false);
        } catch (error) {
          setIsPendingSlipData(false);
          console.error("Error fetching data:", error);
        } finally {
          setOnResourceSelectionAPIsCalls(false);
        }
      })();

      // const selectedSlip = employeeDDLItems.find((employee: any) => employee.value === selectedEmployee)?.totalSlips.find((slip: any) => slip.id === selectedItem.value);

      // setT4SlipRecord(selectedSlip);
      // slipDataByIdPass(selectedSlip, true);
      // selectedSlipTypee = formMethods.getValues("slipType");
      // setSelectedOtherInformation(false);
      // setIsPendingSlipData(false);
    }
    //otherinformation will update selected items
    setSelectedOtherInformation(true);
  };


  // // when Screens Reloads then which data loaded
  // useEffect(() => {
  //   if (id !== undefined && onResourceSelectionAPIsCalls === false && employeeDDLItems) {
  //     const employeeOrSlip: { isSlipData: boolean, data: any, selectedEmployee?: any } | null = findEmployeeOrSlip(employeeDDLItems, id)
  //
  //     if (employeeOrSlip && employeeOrSlip.isSlipData) {
  //       // slip DDL
  //       if (employeeOrSlip.selectedEmployee.totalSlips && Array.isArray(employeeOrSlip.selectedEmployee.totalSlips)) {
  //         let resourceSlipList: any[] =
  //           employeeOrSlip.selectedEmployee.totalSlips.map((resourceSlip: any) => ({
  //             label: resourceSlip.label,
  //             value: resourceSlip.value,
  //             totalSlips: resourceSlip.totalSlips
  //           }));

  //         resourceSlipList.unshift({
  //           label: "Create New",
  //           value: "create-new",
  //         });


  //     
  //         setSelectedResourceSlipList(resourceSlipList);
  //       }
  //       setT4SlipRecord(employeeOrSlip.data)
  //       setSelectedResourceSlip(
  //         String(employeeOrSlip.data.value)
  //       );
  //       formMethods.setValue(
  //         "selectedSlip",
  //         String(employeeOrSlip.data.value)
  //       );
  //       slipDataByIdPass(employeeOrSlip.data, true);
  //       setIsPendingSlipData(false)
  //       selectedSlipTypee = formMethods.getValues("slipType");
  //       setSelectedOtherInformation(false);
  //     } else {
  //       if (employeeOrSlip) {
  //         setSelectedNotStartedResourceData(employeeOrSlip.data.employeeData)
  //         resourceDataByIdPass(employeeOrSlip.data.employeeData);
  //       }
  //     }
  //   }
  // }, [id, onResourceSelectionAPIsCalls, employeeDDLItems]);


  // for edit
  //if slip is completed this will effected
  //if dob is masked then placeholder change
  // const [dateOfBirthPlaceHolder, setDateOfBirthPlaceHolder] = useState("");
  useEffect(() => {
    // if the selected flex field data has loaded.

    if (T4SlipRecord && onResourceSelectionAPIsCalls === false) {
      slipDataByIdPass(T4SlipRecord, onResourceSelectionAPIsCalls);
      setIsPendingSlipData(false);
    }
    selectedSlipTypee = formMethods.getValues("slipType");
    setSelectedOtherInformation(false);
  }, [
    T4SlipRecord,
    formMethods.setValue,
    formMethods,
    id,
    onResourceSelectionAPIsCalls,
  ]);

  // useEffect(() => {
  //   if (T4SlipRecord && onResourceSelectionAPIsCalls === false) {
  //     slipDataByIdPass(T4SlipRecord, onResourceSelectionAPIsCalls);
  //     setIsPendingSlipData(false);
  //   }

  // }, [T4SlipRecord, formMethods.setValue, formMethods, id, onResourceSelectionAPIsCalls]);

  // //this is for not started slip
  useEffect(() => {
    // if the selected flex field data has loaded.
    if (
      selectedNotStartedResourceData &&
      onResourceSelectionAPIsCalls === false
    ) {
      resourceDataByIdPass(selectedNotStartedResourceData);
      setIsPendingSlipData(false);
    }
  }, [
    selectedNotStartedResourceData,
    formMethods.setValue,
    formMethods,
    onResourceSelectionAPIsCalls,
  ]);

  // when  I formMethods.setValue of otherinformation inside async calls method then facing issue while click on add more so we have to use state method to show otherinformation
  useEffect(() => {

    if (
      slipOtherInformation &&
      slipOtherInformation !== null &&
      slipOtherInformation.length !== 0
    ) {

      setOiInEdit(true);
      formMethods.setValue("comparison", slipOtherInformation);
    } else if (!id) {
      setOiInEdit(true);
      formMethods.setValue("comparison", [
        {
          amount: null,
          code: "",
          label: "",
        },
      ]);
    }
    // else if (!id) {
    // 	defaultSettingsCalls();
    // }
  }, [slipOtherInformation]);

  const onSlipTypeSelectionChangeHandler = (e: any) => {
    setIsPendingSlipData(true);
    setTimeout(() => {
      setIsPendingSlipData(false);
    }, 1000);
    const selectedType = e.value;
    selectedSlipTypee = selectedType;
    // alert(selectedType);
  };

  const onCloseHandler = () => {
    setDialogOpen(false);
    setInvoiceDialogOpen(false);
  };





  // const getCardStyles = (index: any) => {

  // 	return {
  // 		borderLeft:
  // 			selectedEmployee === index ? "6px solid #0091b3" : "2px solid transparent",
  // 		cursor: "pointer",
  // 	};
  // };
  // const getSelectedResourceSlipInDataTable = (index: any) => {
  // 	let selectedItem =
  // 		selectedEmployee === index ? selectedResourceSlip : "create-new";
  // 	return selectedItem;
  // };
  // const getSelectedResourceSlipsListInCard = (index: any) => {
  // 	let selectedList =
  // 		selectedEmployee === index
  // 			? selectedResourceSlipList
  // 			: [{ label: "Create New", value: "create-new" }];
  // 	return selectedList;
  // };

  const tableScrollRef = useRef<HTMLDivElement>(null);
  const upadtedEmployeeDDLListItems = useMemo(() => {
    return (
      resourceListWithoutCreateNew &&
      resourceListWithoutCreateNew.map((item: any) => ({
        ...item,
        label: (
          <span
            // to={`/compliance/t4/setup${item.value}`}
            // className="no-underline"
            style={{ color: theme.palette.primary.light, cursor: "pointer" }}
            onClick={() => {
              onResourceSelectionChangeHandler(item);
              scrollPanelFieldsToTop();
            }}
          >
            {item.label}
          </span>
        ),
      }))
    );
  }, [resourceListWithoutCreateNew]);

  // const filteredResourceList =
  // 	resourceListWithoutCreateNew &&
  // 	resourceListWithoutCreateNew.filter((item: any) =>
  // 		item.label.toLowerCase().includes(itemSearch.toLowerCase())
  // 	);

  // const onCreateNewButtonClicked = () => {
  // 	formMethods.setValue("comparison", [{ amount: 0, code: "", label: "" }]);
  // 	formMethods.reset();
  // 	formMethods.setValue("comparison", [{ amount: 0, code: "", label: "" }]);
  // 	setSlipOtherInformation([]);
  // 	formMethods.setValue("employmentIncome", undefined);
  // 	setDateOfBirth("");
  // 	setDateOfBirthPlaceHolder("");
  // 	setSelectedResourceSlipList([{ label: "Create New", value: "create-new" }]);
  // 	setSelectedResourceSlip("create-new");

  // 	//otherinformation will update selected items
  // 	setSelectedOtherInformation(false);
  // 	// if(id !== undefined){
  // 	//   window.location.href = "/compliance/t4/setup";
  // 	// }
  // 	let path = `/compliance/t4/setup`;
  // 	navigate(path);
  // 	setT4SlipRecord(undefined);
  // 	setIsPendingSlipData(true);
  // 	setTimeout(() => {
  // 		setIsPendingSlipData(false);
  // 	}, 1000);
  // 	//otherinformation will update selected items
  // 	setSelectedOtherInformation(false);
  // 	setSelectedResource("create-new");
  // 	setSelectedEmployee(null);
  // 	defaultSettingsCalls();

  // 	//because of issue in slipdata values not clear issue
  // 	window.location.reload();
  // };
  // const onDividerButtonClickHandler = () => {
  // 	setSidePanelsVisibility((prevButtonState: any) => !prevButtonState);
  // };

  const drawerMenuOptions = useSelector(
    (state: IAppState) => state.drawerMenu.menu
  );

  const expandedLabels = ["Compliance", "T4"];
  const expandedT4SetupItem = "Setup";
  const enhanceData = (data: any[], parentLabel?: string): any[] => {
    return data.map((item) => {
      let isExpanded = expandedLabels.includes(item.label);
      if (parentLabel === "T4" && item.label === expandedT4SetupItem) {
        isExpanded = true;
      }
      const enhancedItem = {
        ...item,
        expanded: item.items ? isExpanded : false,
        items: item.items ? enhanceData(item.items, item.label) : undefined,
        path: parentLabel === "T4" && item.label === expandedT4SetupItem && "/compliance/t4/setup",
      };
      return enhancedItem;
    });
  };

  useEffect(() => {
    dispatch(
      setSelectedActivityLogActions({
        entityId1: id ? id : "",
        entityId2: "",
        entityId3: "",
        screenName: T4_SETUP_SCREEN_SLUG,
        companyName: clientName,
        activityType:
          "activity_type=create&activity_type=updated&activity_type=delete&activity_type=print",
        activityLogVisibility: true,
      })
    );
    dispatch(setSelectedStickyNavBar({ isSticky: true }));
    if (drawerMenuOptions && drawerMenuOptions.length > 0) {
      const enhancedData = enhanceData(drawerMenuOptions);
      dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
    }
  }, [drawerMenuOptions]);

  console.log('selectedEmployeeselectedEmployee', selectedEmployee)
  console.log('provinceOfEmploymentIdprovinceOfEmploymentId', provinceOfEmploymentId)
  return (
    <>
      <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
        <BackdropCircularProgress
          open={
            isPendingEmployeeDDLItems ||
            // isPendingResourceSlips ||
            // isPendingSlipData ||
            isSubmitting ||
            isPendingData ||
            // isPendingResourceInfo ||
            // reFetchingSlipData ||
            isPendingSlipData ||
            // isPendingProvinceDropDownList ||
            isPendingSlipListDDL ||
            // isPendingNotStartedSlipId ||
            isDeleting ||
            // isPendingNotStartedSlipId ||
            isPendingDataa ||
            // isPendingGlobalVariables ||
            isPendingActivityLogData
            // isPendingT4OtherInformationList
          }
          testId={testId}
        />
        <DeleteConfirmationDialog
          open={openDialog}
          deleteActionHandler={deleteT4SlipField}
          cancelActionHandler={onCloseHandler}
          testId="T4-confirmation-dialog"
        />
        {/* <Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}> */}
        {/* {sidePanelsVisibility && (
						<Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}>
							<Box sx={{ margin: "0" }}>
								<InputText
									value={itemSearch}
									onChange={(e) => setItemSearch(e.target.value)}
									placeholder={"Search by name..."}
									className="w-full search-field"
								/>
							</Box>
							<Box
								sx={{
									// display: "flex",
									height: "95rem",
									// flexDirection: "column",
									overflow: "auto",
									"&::-webkit-scrollbar": {
										width: "0.4em",
									},
									"&::-webkit-scrollbar-thumb": {
										background: "#ccc",
										borderRadius: "3px",
									},
									"&::-webkit-scrollbar-thumb:hover": {
										backgroundColor: "#aaa",
									},
								}}
							>
								{resourceListWithoutCreateNew &&
									filteredResourceList.map((item: any, index: any) => {
										return (
											<Card
												sx={{
													padding: 0,
													borderRadius: "8px",
													marginBottom: "1rem",
												}}
												key={index}
												onClick={() =>
													onResourceSelectionChangeHandler(item, item.value)
												}
												style={getCardStyles(item.value)}
											>
												<Box
													sx={{
														display: "flex",
														justifyContent: "space-between",
														padding: "0.8rem",
														alignItems: "center",
													}}
												>
													<Typography
														sx={{ fontWeight: "bold", fontSize: ".875rem" }}
													>
														{item.label}
													</Typography>
													<Avatar
														shape="circle"
														style={{
															background: "#0091b3",
															color: "#fff",
															borderRadius: "50%",
															fontWeight: "bold",
															fontSize: ".775rem",
															padding: "2px",
														}}
													>
														{item.label
															.replace(/\s+/g, " ")
															.split(" ")
															.filter((word: string) => word.trim() !== "")
															.map((word: string) => word[0].toUpperCase())
															.slice(0, 2)
															.join("")}
													</Avatar>
												</Box>
												{selectedEmployee === item.value ? (
													<>
														<Divider className="m-0" />
														<Box>
															<Box sx={{ padding: "0.6rem" }}>
																<Dropdown
																	value={getSelectedResourceSlipInDataTable(
																		item.value
																	)}
																	onChange={
																		onResourceSlipSelectionChangeHandler
																	}
																	options={getSelectedResourceSlipsListInCard(
																		item.value
																	)}
																	onClick={(e: any) => e.stopPropagation()}
																	className="slip-dropdown"
																/>
															</Box>
														</Box>
													</>
												) : (
													<></>
												)}
											</Card>
										);
									})}
							</Box>
						</Grid>
					)}
					<Divider
						layout="vertical"
						align="center"
						className="verticle-divider"
						style={{ zIndex: 0 }}
					>
						<Button
							variant="outlined"
							sx={{
								minWidth: "fit-content",
								padding: "20px 0",
								borderRadius: "7px",
							}}
							onClick={onDividerButtonClickHandler}
						>
							{sidePanelsVisibility ? (
								<i
									className="pi pi-angle-double-left"
									style={{ color: "#0091b3" }}
								></i>
							) : (
								<i
									className="pi pi-angle-double-right"
									style={{ color: "#0091b3" }}
								></i>
							)}
						</Button>
					</Divider> */}
        {/* <Grid
						// item
						// xs={sidePanelsVisibility ? 8 : 10}
						// sm={sidePanelsVisibility ? 8 : 10.8}
						// md={sidePanelsVisibility ? 9.4 : 11.2}
						// lg={sidePanelsVisibility ? 9.5 : 11.6}
						// xl={sidePanelsVisibility ? 9.7 : 11.7}
						size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
						sx={{ "& .MuiGrid-container": { marginTop: 0 } }}
					> */}
        <FormProvider {...formMethods}>
          <form onSubmit={formMethods.handleSubmit(onSubmit)}>
            <Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
              <Grid
                size={{ xs: 12, sm: 12, md: 8, lg: 8, xl: 8 }}
                sx={{
                  borderRadius: "3px",
                }}
              >
                <TwoColumnLayout
                  toolbar={
                    <T4SlipSetupToolbar
                      onResetClicked={onResetClicked}
                      onDeleteClicked={onDeleteClicked}
                      onPrintClicked={onPrintClicked}
                      isSubmitting={false}
                      formMethods={formMethods}
                      t4SummaryData={t4SummaryData && t4SummaryData}
                      t4SummaryReduceEIData={
                        t4SummaryReduceEIData && t4SummaryReduceEIData
                      }
                      pageTitle="T4 Setup"
                      id={id}
                    />
                  }
                  leftColumnContent={
                    <>
                      {/* {!sidePanelsVisibility && (
												<StandardPanel
													title="Load Slips"
													testId={`${testId}-load-slips-panel`}
													variant="outlined"
													borderHide={true}
												>
													<Grid
														container
														columnSpacing={2}
														size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
													>
														<Grid
															size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}
														>
															<EnhancedDropDownRHFWithLabel
																label="Load Employee"
																selectName="selectedEmployee"
																items={selectedResourceList}
																selectedItem={selectedResource}
																testId="selected-employee"
																onSelectionChangeHandler={
																	onResourceSelectionChangeHandler
																}
																// isPending={isPendingFlexFieldsList}
															/>
														</Grid>
														<Grid
															size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}
														>
															<EnhancedDropDownRHFWithLabel
																label="Load T4 Slip"
																selectName="selectedSlip"
																items={selectedResourceSlipList}
																selectedItem={selectedResourceSlip}
																testId="selected-slip"
																onSelectionChangeHandler={
																	onResourceSlipSelectionChangeHandler
																}
																// isPending={isPendingFlexFieldsList}
															/>
														</Grid>
													</Grid>
												</StandardPanel>
											)} */}
                      <StandardPanel
                        title="Slip Data"
                        testId={`${testId}-slip-data`}
                        // topPadding={!sidePanelsVisibility ? 2 : 0}
                        // variant="outlined"
                        borderHide={true}
                      >
                        {T4OtherInformationList && (
                          <T4SlipDataPanel
                            formMethods={formMethods}
                            isLoading={false}
                            otherInformationList={T4OtherInformationList}
                            testId={testId}
                            selectedOtherInformation={selectedOtherInformation}
                            oiInEdit={oiInEdit}
                            selectedProvinceOfEmployment={
                              selectedProvinceOfEmployment
                            }
                          // globalVariablesData={
                          //   globalVariablesData && globalVariablesData
                          // }
                          />
                        )}
                      </StandardPanel>
                    </>
                  }
                  rightColumnContent={
                    <>
                      <StandardPanel
                        title="Employee Info"
                        testId={`${testId}-employee-info`}
                        borderHide={true}
                        borderBottom={true}
                      >
                        <EmployeeInfoSetupFieldsPanel
                          onDateOfBirthChangeHandler={
                            onDateOfBirthChangeHandler
                          }
                          testId={testId}
                        />
                        {/* <FieldWrapper>
													<FieldLayout
														label="Date of Birth"
														// isRequired={isRequired}
														testId={testId}
														labelPosition={LabelPosition.Top}
														labelColumns={4}
														fieldColumns={8}
													>
														<Calendar
															id="dateOfBirth"
															{...formMethods.register("dateOfBirth")} // Register the input with react-hook-form using methods.register
															value={formMethods.watch("dateOfBirth") || null} // Set the value using watch to reflect changes
															showIcon
															// dateFormat="dd/mm/yy" // Customize the date format as needed
															placeholder={
																dateOfBirthPlaceHolder !== "" ||
																dateOfBirthPlaceHolder.charAt(2) === "*"
																	? "Unmask to view / edit"
																	: "dd/mm/yyyy"
															}
															disabled={
																dateOfBirthPlaceHolder !== "" &&
																dateOfBirthPlaceHolder.charAt(2) === "*"
															} //if unmask then it is enabled
															// className="w-full"
															style={{ height: "2.6rem" }}
															onChange={onDateOfBirthChangeHandler}
															dateFormat="M dd, yy"
															required={
																defaultSettingsData &&
																!defaultSettingsData.message &&
																defaultSettingsData.fillingDataAttribute
																	.employeeDobIsRequired
															}
															// invalid={true}
															className={`w-full calender ${
																defaultSettingsData &&
																!defaultSettingsData.message &&
																defaultSettingsData.fillingDataAttribute
																	.employeeDobIsRequired &&
																dateOfBirth === ""
																	? "p-invalid"
																	: ""
															}`}
														/>
														{defaultSettingsData &&
														!defaultSettingsData.message &&
														defaultSettingsData.fillingDataAttribute
															.employeeDobIsRequired &&
														dateOfBirth === "" ? (
															<small
																className="p-error"
																style={{ paddingLeft: "1rem" }}
															>
																Date is required.
															</small>
														) : (
															<></>
														)}
													</FieldLayout>
												</FieldWrapper> */}
                      </StandardPanel>
                      <StandardPanel
                        title="Address"
                        testId={`${testId}-employee-address-panel`}
                        // topPadding={2}
                        borderHide={true}
                        borderBottom={true}
                      >
                        <EmployeeAddressSetupFieldsPanel
                          testId={testId}
                          countryList={countryList}
                          formMethods={formMethods}
                          provinceDDLLoading={(value: boolean) =>
                            setProvinceDDLLoading(value)
                          }
                          provinceStateLabelinUpdate={
                            provinceStateLabelinUpdate &&
                            provinceStateLabelinUpdate
                          }
                          provinceStateDDLinUpdate={
                            provinceStateDDLinUpdate && provinceStateDDLinUpdate
                          }
                          provinceDDLItems={(value: any) =>
                            setProvinceDDLItems(value)
                          }
                          cityDDLinUpdate={cityDDLinUpdate && cityDDLinUpdate}
                          isAdminUser={isAdminUser}
                          loadedSlipId={id}
                        />

                        {/* <EnhancedDropDownRHFWithLabel
                        selectName="province"
                        label="Province"
                        // selectedItem={selectedProvince.id !== null && selectedProvince}
                        labelPosition={LabelPosition.Left}
                        required
                        testId={`${testId}-province-list`}
                        items={provinceList ?? []}
                        onSelectionChangeHandler={onProvinceSelectionChangeHandler}
                      /> */}
                      </StandardPanel>
                      <StandardPanel
                        title="Filing Data"
                        testId={`${testId}-filing-data-panel`}
                        borderHide={true}
                      >
                        <EnhancedDropDownRHFWithLabel
                          label="Slip Type"
                          selectName="slipType"
                          items={[
                            { label: "Original", value: 400 },
                            { label: "Amended", value: 200 },
                            { label: "Cancelled", value: 300 },
                            { label: "Additional", value: 100 },
                          ]}
                          selectedItem={400}
                          testId="slip-type"
                          labelPosition={LabelPosition.Top}
                          required
                          onSelectionChangeHandler={
                            onSlipTypeSelectionChangeHandler
                          }
                        />
                        <FilingDataSetupFieldsPanel
                          formMethods={formMethods}
                          onPOEchange={(value) =>
                            setSelectedProvinceOfEmployment(value)
                          }
                          showbox17IfQC={showbox17IfQC}
                          // globalVariablesData={
                          //   globalVariablesData && globalVariablesData
                          // }
                          provinceDDLItems={
                            provinceDDLItems && provinceDDLItems
                          }
                          payFrequencyDDLItems={
                            payFrequencyDDLItems && payFrequencyDDLItems
                          }
                        />
                      </StandardPanel>
                    </>
                  }
                  testId="t4-slip-setup-form"
                />
              </Grid>
              <Grid size={{ xs: 0, sm: 0, md: 1, lg: 1, xl: 1 }}></Grid>
              <Grid
                size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}
                sx={{ marginTop: "16px" }}
              >
                <ResourceDDLDataTableForSlips
                  rows={
                    employeeDDLItems && upadtedEmployeeDDLListItems
                      ? upadtedEmployeeDDLListItems
                      : []
                  }
                  // onRowEditClicked={onRowEditClicked}
                  // onRowDeleteClicked={onRowDeleteClicked}
                  // onRowArchiveClicked={onArchiveClicked}
                  // isLoading={isPending}
                  // totalRecords={
                  // 	departmentsList && departmentsList.total
                  // 		? departmentsList.total
                  // 		: 0
                  // }
                  // initialPageSize={INITIAL_PAGE_SIZE}
                  // rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
                  // onRequestParamsChange={onRequestParamsChange}
                  selectedEmployee={selectedEmployee}
                  selectedResourceSlipList={selectedResourceSlipList}
                  selectedResourceSlip={selectedResourceSlip}
                  onResourceSlipSelectionChangeHandler={
                    onResourceSlipSelectionChangeHandler
                  }
                  tableScrollHeight={"60vh"}
                  // selectedId={T4SlipRecord && id && T4SlipRecord?.resource?.externalId}
                  selectedId={selectedEmployee}
                  tableContainerRef={tableScrollRef}
                />
              </Grid>
              <Grid size={{ xs: 0, sm: 0, md: 0, lg: 1, xl: 1 }}></Grid>
            </Grid>
          </form>
        </FormProvider>
        {/* </Grid>
				</Grid> */}
        {/* invoice dialogu open if any transaction is unPaid */}
        <EnhancedDialog
          dialogTitle="Invoice(s) Due"
          key="dialog-box-1"
          testId="dialog"
          onCloseHandler={onCloseHandler}
          open={openInvoiceDialog}
          dialogContent={
            <InvoiceDialogPanel
              invoiceData={invoiceData}
              onUnPaidClickHandler={onUnPaidClickHandler}
              onClickInvoiceNoHandler={onClickInvoiceNoHandler}
            />
          }
          dialogAction={
            <Grid>
              <Button autoFocus variant="contained" onClick={onCloseHandler}>
                Cancel
              </Button>
            </Grid>
          }
        />
        <EnhancedSnackbar
          message={snackbarData.message}
          onCloseHandler={onSnackbarClosed}
          severity={snackbarData.severity}
          testId={`${testId}-snackbar`}
          open={snackbarData.open}
          autoHide={snackbarData.autoHide}
        />
      </Grid>
    </>
  );
};
